var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isShown)?_c('div',{staticClass:"page-loader-container fade-in"},[_c('div',{staticClass:"page-loader"},[_vm._v("Loading...")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }